import { toast } from "react-toastify";
import { CompanyDetailID } from "../data";
import { setAllPreloadedApi } from "../store/preloadedApisSlice";
const fetchAllData = async (
  dispatch,
  getLocations,
  getCourts,
  setLoading = () => {}
) => {
  setLoading(true);
  try {
    const result = await getLocations({ companyDetailID: CompanyDetailID });
    const result2 = await getCourts({
      search: "",
      pageNumber: 1,
      pageSize: 10000000,
      showInactive: false,
      showUpcoming: false,
    });

    if (result?.data?.headers?.error !== 200) {
      toast.error(result?.data?.headers?.message || "Unknown error");
      return null;
    } else if (result2?.data?.headers?.error !== 200) {
      toast.error(result?.data?.headers?.message || "Unknown error");
      return null;
    } else {
      const transformedData = {
        locations: result?.data?.body?.items,
        courts: result2?.data?.body?.items,
        blockedSlots: [],
      };

      console.log("transformed Data", transformedData);
      dispatch(setAllPreloadedApi(transformedData));
      return transformedData;
    }
  } catch (err) {
    toast.error(new Error(err.message)?.message);
  } finally {
    setLoading(false);
  }
};

export default fetchAllData;
